import React from 'react';

const Disclaimerpopup = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-lg space-y-6 text-sm md:text-base text-gray-700 ">
      <h2 className="text-2xl font-semibold text-[#3D6643]">Disclaimer </h2>

      <p>
        The information provided by Stay Cool (“we,” “us,” or “our”) on our vacation rental platform is for general informational purposes only. While we strive to ensure that all information is accurate and up-to-date, we make no guarantees of any kind regarding its accuracy, completeness, reliability, or suitability.
      </p>

      <h3 className="text-lg font-semibold mt-4">1. Property Listings</h3>
      <p>
        Stay Cool is a platform that facilitates the listing and booking of rental properties. We do not own, manage, or control the properties listed. All property details, availability, and pricing are provided by the hosts or property managers. We are not responsible for any inaccuracies in these listings.
      </p>

      <h3 className="text-lg font-semibold mt-4">2. Booking and Payments</h3>
      <p>
        While we facilitate the booking process, Stay Cool is not liable for issues arising between hosts and guests, including cancellations, property conditions, or non-payment. All financial transactions are processed through third-party services, and we do not store sensitive payment information.
      </p>

      <h3 className="text-lg font-semibold mt-4">3. No Legal or Financial Advice</h3>
      <p>
        The content on Stay Cool’s platform is not intended to be a substitute for legal, financial, or real estate advice. Users are encouraged to consult professionals before making any decisions based on the information found on the platform.
      </p>

      <h3 className="text-lg font-semibold mt-4">4. Platform Availability</h3>
      <p>
        We aim to provide uninterrupted access to our platform, but we do not guarantee that the site will always be available or free from errors, downtime, or bugs. Maintenance, updates, and technical issues may affect accessibility.
      </p>

      <h3 className="text-lg font-semibold mt-4">5. External Links</h3>
      <p>
        Our platform may contain links to third-party websites or services. Stay Cool does not endorse or assume responsibility for the content, privacy policies, or practices of these external sites.
      </p>

      <h3 className="text-lg font-semibold mt-4">6. Limitation of Liability</h3>
      <p>
        To the fullest extent permitted by law, Stay Cool disclaims all warranties, express or implied, and shall not be liable for any loss or damage arising from your use of the platform, including direct, indirect, incidental, or consequential damages.
      </p>

      <h3 className="text-lg font-semibold mt-4">7. Changes to This Disclaimer</h3>
      <p>
        Stay Cool reserves the right to modify this disclaimer at any time without prior notice. Your continued use of the platform signifies your acceptance of the updated terms.
      </p>

      

      <p className="text-xs text-gray-500">Effective Date: July 26, 2025</p>
    </div>
  );
};

export default Disclaimerpopup;
